export const CHECKBOX = 'checkbox';
export const RADIO = 'radio';
